module.exports = __webpack_public_path__ + "static/media/logo_smak.7491e8df.svg";